module.exports = __webpack_public_path__ + "img/photo-5.387ee76d.jpg";